import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioIntegracionHcService {

  constructor(private requestUrl: ReportesRequestService) { }

  public async getEventos( params: ParametrosIntegracionEntity ) {
    try {
      const response = await this.requestUrl.getRequest(
        'integracion-hc/eventos', [ params.codigoBaseDatos, {
          uncoParametroSimens: params.uncoParametroSimens,
          uncoAfiliado: params.uncoAfiliado
        } ]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }
}

export interface ParametrosIntegracionEntity {
  codigoBaseDatos: string;
  uncoParametroSimens: string;
  uncoAfiliado: string;
}

export interface EventosEntity {
  idTransformador: string;
  informacion: InformacionEntity;
  contacto: ContactoEntity;
  tecnologias: [TecnologiaEntity];
  resultados: [ResultadoEntity];
}

interface InformacionEntity {
  nacionalidad: {
    codigo: string;
    nombre: string;
  };
  identificacion: {
    tipo: string;
    numero: string;
  };
  nombres: {
    apellido1: string;
    apellido2: string;
    nombre1: string;
    nombre2: string;
  };
  fechaNacimiento: string;
  edadEstimada: {
    unidad: string;
    valor: number;
  };
  edad: string;
  sexo: string;
  genero: string;
  ocupacion: {
    codigo: string;
    nombre: string;
  };
  voluntadAnticipada: {
    tipo: number;
    fecha: string;
  };
  discapacidad: string;
  paisResidencia: {
    codigo: string;
    nombre: string;
  };
  municipioResidencia: {
    codigo: string;
    nombre: string;
  };
  etnia: string;
  comunidad: {
    codigo: string;
    nombre: string;
  };
  zona: string;
  eps: {
    codigo: string;
    nombre: string;
  };
  estadoCivil: string;
}

interface ContactoEntity {
  fechaHora: string;
  modalidad: number;
  entorno: number;
  viaIngreso: number;
  causa: number;
  fechaTriage: string;
  clasificacion: number;
  diagnostico: {
    codigo: string;
    nombre: string;
  }
  tipoDiagnostico: number;
  ips: {
    codigo: string;
    nombre: string;
  }
  tipoConsulta: {
    codigo: number;
    nombre: string;
  },
  tipoUsuario: string;
  tipoAfiliado: string;
  condicionUsuaria: string;
  enfermedadActual: string;
  admision: string;
  data: {
    modalidad: string;
    entorno: string;
    viaIngreso: string;
    causa: string;
    clasificacion: string;
    tipoDiagnostico: string;
    tipoUsuario: string;
    tipoAfiliado: string;
    condicionUsuaria: string;
  }
}

interface TecnologiaEntity {
  tipo: string;
  fechaHora: string;
  tecnologia: {
    codigo: string;
    nombre: string;
  },
  finalidad: string;
  medicamento: {
    forma: string;
    concentracion: string;
    unidad: string;
  },
  dosis: string;
  via: string;
  frecuencia: string;
  duracion: number;
  cantidad: number;
  profesional: {
    tipo: string;
    numero: string;
    nombre: string;
  }
}

interface ResultadoEntity {
  tipoDiagnostico: number;
  tipoDiagnosticoRes: string;
  diagnostico: {
    codigo: string;
    nombre: string;
  };
  diagnosticoRelacionado1: {
    codigo: string;
    nombre: string;
  };
  diagnosticoRelacionado2: {
    codigo: string;
    nombre: string;
  };
  diagnosticoRelacionado3: {
    codigo: string;
    nombre: string;
  };
  fechaValoracion: string;
  instrumento: string;
  parametro: string;
  valor: number;
  diagnosticoComplicacion: {
    codigo: string;
    nombre: string;
  };
  condicion: number;
  condicionRes: string;
  diagnosticoMuerte: {
    codigo: string;
    nombre: string;
  };
  fechaFinalizacion: string;
  prestadorRefiere: {
    codigo: string;
    nombre: string;
  };
  tipoIncapacidad: number;
  tipoIncapacidadRes: string;
  diasIncapacidad: number;
  diasMaternidad: number;
  antecedenteAlergias: number;
  antecedenteAlergiasRes: string;
  antecedenteFamiliar: {
    condicion: string;
    parentesco: string;
  };
  factorRiesgo: {
    tipo: string;
    nombre: string;
  };
  profesional: {
    tipo: string;
    numero: string;
    nombre: string;
  };
  planTratamiento: string;
}